import { PfeActionConfig } from '../pfe-actions/pfe-actions.model';
import { AppConfiguration } from './app-configuration.model';
import { PageNavigationConfiguration, PfeNavigationConfiguration } from './navigation-config.model';
import { NgxPfeConfig, PageConfig } from './ngx-pfe-page-config.model';

/**
 * This file contains the data models that are used for the json schemas that are shipped with the PFE.
 *
 * typescript-json-schema is currently not able to handle default generics:
 * @see https://github.com/YousefED/typescript-json-schema/issues?utf8=%E2%9C%93&q=is%3Aissue+is%3Aopen+generic
 * As a workaround, they are made specific here.
 */

type JsonSchemaAttribute = {
  /** The JSON Schema for this file */
  $schema?: string;
};

export type DefaultNgxPfeConfig = NgxPfeConfig<AppConfiguration, PageConfig, PfeActionConfig> & JsonSchemaAttribute;

export type DefaultPfeNavigationConfiguration = PfeNavigationConfiguration<PfeActionConfig> & JsonSchemaAttribute;

export type DefaultAppConfiguration = AppConfiguration & JsonSchemaAttribute;

// Used by the config editor:
export type DefaultPageNavigationConfiguration = PageNavigationConfiguration<PfeActionConfig>;
